import { DataSource, HorizontalSpacer, Image, Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutTaxControlVersion extends Layout {
    horizontalspacer1: HorizontalSpacer;
    imageCopy: Image;
    labelChangelog: Label;
    labelChanges: Label;
    labelVersion: Label;
    labelVersionTitle: Label;
    panelChangelog: Panel;
    panelTaxTableInfo: Panel;
    sourceTaxControlVersion: DataSource;
}
